module.exports = __webpack_public_path__ + "assets/images/intro/covid-hits-home-scrollyimage3.jpg?v=00233233";